export default __webpack_public_path__ + "static/media/gallery43.1ff806a3.webp";